import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import { withStyles, Grid, Typography } from '@material-ui/core'

import PropertyCard from './PropertyCard'
import Loader from './Loader'

const styles = theme => ({
  root: {
    display: 'block',
    padding: '15px 0 0',
    [theme.breakpoints.down('xs')]: {
      padding: '15px 0 0',
    },
  },
  gridList: {
    margin: '0px auto',
    width: 'auto',
    maxWidth: '1240px',
    [theme.breakpoints.down('1241')]: {
      maxWidth: '930px',
    },
    [theme.breakpoints.down('931')]: {
      maxWidth: '620px',
    },
    [theme.breakpoints.down('621')]: {
      maxWidth: '310px',
    },
  },
  homeGridCard: {
    margin: '10px',
    padding: '0 !important',
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  listingTitle: {
    fontSize: 28,
    letterSpacing: '-0.5px',
    color: '#2d3447',
    marginTop: 0,
    lineHeight: 1,
    padding: '0 0px',
  },
  smartwayTitle: {
    fontSize: '32px',
    fontWeight: '500',
    color: '#00bcb5',
    lineHeight: '100%',
    padding: '56px 10px 10px',
    [theme.breakpoints.down('1025')]: {
      padding: '30px 10px 10px',
      fontSize: '26px',
    },
    [theme.breakpoints.down('767')]: {
      padding: '20px 10px 10px',
      fontSize: '24px',
    },
  },
  listLink: {
    outline: 'none',
    display: 'block',
    fontSize: 0,
    '&:hover': {
      boxShadow: '0 7px 23px rgba(0,0,0,0.14), 0 10px 10px rgba(0,0,0,0.04)',
    },
  },
})

const MOBILE_BREAKPOINT = process.env.REACT_APP_TABLET_BREAKPOINT

class PropertyList extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    properties: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      width: window.innerWidth,
    }
  }

  render() {
    const { isLoading, classes, properties, onSelect, title, from } = this.props
    const style = from === 'saved' && this.state.width > MOBILE_BREAKPOINT ? { marginLeft: '65px' } : {}
    return (
      <div className={classes.root}>
        <Grid container spacing={24} className={classes.gridList}>
          {/* <div className={classes.smartwayTitle}>A Smarter Way To Buy Investment Properties</div> */}
          <Grid item xs={12} style={{ padding: '15px 10px 20px' }}>
            <Typography className={classes.listingTitle}>{title}</Typography>
          </Grid>
          {isLoading ? (
            <Loader style={{ margin: '30px auto' }} />
          ) : (
            properties.length > 0 &&
            properties.map((p, ix) => (
              <Grid item className={`${classes.homeGridCard} grid-card`} value={p} key={p.id} style={style}>
                <Link to={`/listings/${p.id}`} onClick={onSelect} className={classes.listLink}>
                  <PropertyCard key={`prop_${ix}`} property={p} noMap largeCard />
                </Link>
              </Grid>
            ))
          )}
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(PropertyList)



// WEBPACK FOOTER //
// ./src/components/PropertyList.js